import React from 'react'
import { Row, Col, FormControl, Button } from 'react-bootstrap'
import { Link } from 'react-router'
import moment from 'moment'
import i18next from 'i18next'
import classnames from 'classnames'

import Paginator from './Paginator'
import Loading from './Loading'
import GridContainer from './GridContainer'
import NoWopi360Results from './NoWopi360Results'
import Notificator from './Notificator'

import buttonStyles from './styles/button.scss'
import listingStyles from './styles/listing.scss'
import searchIcon from './../assets/images/search.png'
import Wopi360TargetListTable from './Wopi360TargetListTable'

export default class Wopi360TargetList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      keyword: '',
      language: this.props.currentLanguage
    }
  }

  componentDidMount() {
    const { onSearch, currentOrganisationId } = this.props

    onSearch({ organisationId: currentOrganisationId, filters: { status: 'closed' } })
  }

  handlePagination = page => {
    this.props.onSearch({
      organisationId: this.props.currentOrganisationId,
      keyword: this.state.keyword,
      filters: this.props.searchFilters,
      page
    })
  }

  handleChangeKeyword = e => {
    this.setState({ keyword: e.target.value })
  }

  handleSearch = e => {
    e.preventDefault()

    const { onSearch, currentOrganisationId, searchFilters } = this.props

    onSearch({
      organisationId: currentOrganisationId,
      keyword: this.state.keyword,
      filters: searchFilters
    })
  }

  handleSearchWithFilters = searchFilters => e => {
    e.preventDefault()

    const { onSearch, currentOrganisationId } = this.props

    onSearch({
      organisationId: currentOrganisationId,
      keyword: this.state.keyword,
      filters: searchFilters,
      page: 1
    })
  }

  handleDeleteClick = uuid => {
    if (confirm(i18next.t('are_you_sure'))) {
      this.props.onDelete(this.props.currentOrganisationId, uuid)
    }
  }

  handleLanguageChange = language => {
    this.setState({ language })
  }

  render() {
    const { language } = this.state

    const {
      wopi360Targets,
      searchFilters,
      pagination,
      currentLanguage,
      deletedWopi360Targets,
      closedWopi360Target
    } = this.props

    moment.locale(currentLanguage)

    const openList = searchFilters.status === 'open'
    const closedList = !openList

    return (
      <GridContainer>
        <div style={{ marginBottom: 365 }}>
          <Row>
            <Col md={12}>
              {closedWopi360Target && (
                <Notificator type="success">
                  <header>{i18next.t('target_was_closed')}.</header>
                </Notificator>
              )}
            </Col>
          </Row>

          <Row>
            <Col md={8}>
              <header>
                <h1>{i18next.t('wopi360')}</h1>

                <Link
                  id="new-wopi360"
                  to="/new-target"
                  className={buttonStyles.button}
                  style={{ marginLeft: 20 }}
                >
                  {i18next.t('new_wopi360_target')}
                </Link>
              </header>
            </Col>

            <Col md={4}>
              <div className={listingStyles.extraLinks}>
                <form onSubmit={this.handleSearch} style={{ position: 'relative' }}>
                  <FormControl
                    type="text"
                    className={listingStyles.search}
                    placeholder={i18next.t('search_for_targets')}
                    value={this.state.keyword}
                    onChange={this.handleChangeKeyword}
                  />

                  <Button className={listingStyles.searchIcon} onClick={this.handleSearch}>
                    <img src={searchIcon} />
                  </Button>
                </form>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12} className={listingStyles.filters}>
              <Row>
                <Col md={12} style={{ marginBottom: 15 }}>
                  <a
                    id="wopi360-results"
                    href="#"
                    onClick={this.handleSearchWithFilters({ status: 'closed' })}
                    className={classnames({
                      [listingStyles.active]: closedList
                    })}
                  >
                    {i18next.t('closed_targets')}
                  </a>

                  <a
                    href="#"
                    onClick={this.handleSearchWithFilters({ status: 'open' })}
                    className={classnames({
                      [listingStyles.active]: openList
                    })}
                  >
                    {i18next.t('open_targets')}
                  </a>
                </Col>
              </Row>
            </Col>
          </Row>

          <Loading inline={true} isReady={wopi360Targets}>
            {wopi360Targets && (
              <div>
                {wopi360Targets.isEmpty() && (
                  <NoWopi360Results
                    translationKey={
                      openList
                        ? 'open_targets_will_be_listed_here'
                        : 'closed_targets_will_be_listed_here'
                    }
                  />
                )}

                {!wopi360Targets.isEmpty() && (
                  <Wopi360TargetListTable
                    targets={wopi360Targets}
                    deletedTargets={deletedWopi360Targets}
                    latestClosedWopi360TargetUuid={closedWopi360Target}
                    language={language}
                    hasLanguageSelector={searchFilters.status !== 'open'}
                    deleteText={i18next.t('delete')}
                    onDeleteRow={this.handleDeleteClick}
                    onChangeLanguage={this.handleLanguageChange}
                    hideUnits
                  />
                )}

                {pagination && (
                  <Paginator
                    totalCount={pagination.totalCount}
                    page={pagination.page}
                    limit={pagination.limit}
                    onPaginate={this.handlePagination}
                  />
                )}
              </div>
            )}
          </Loading>
        </div>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wopi360TargetList.js